import { alpha, InputBase } from '@mui/material';
import { styled } from '@mui/system';

const SearchCustomInput = styled(InputBase)(({ theme }) => ({
    padding: theme.spacing(0.5),
    paddingLeft: theme.spacing(1.5),
    color: '#fff',
    borderRadius: theme.shape.borderRadius,
    borderWidth: 0,
    height: 39,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    '&:placeholder': {
        color: '#fff',
    },
    '& input': {
        padding: theme.spacing(1),
        width: 330,
    },
}));

export default SearchCustomInput;
